import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, ShoppingCart, Users, Euro, ArrowRight } from "lucide-react";
import api, { eur } from "../../lib/api";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Έσοδα", value: stats ? eur(stats.revenue) : "—", icon: Euro },
    { label: "Παραγγελίες", value: stats?.total_orders ?? "—", icon: ShoppingCart, to: "/admin/orders" },
    { label: "Προϊόντα", value: stats?.total_products ?? "—", icon: Package, to: "/admin/products" },
    { label: "Πελάτες", value: stats?.total_customers ?? "—", icon: Users, to: "/admin/customers" },
  ];

  return (
    <div>
      <h1 className="font-serif-display text-3xl text-[#1E3A2F] mb-1">Επισκόπηση</h1>
      <p className="text-[#536D61] mb-8 text-sm">Καλώς ήρθατε στον πίνακα διαχείρισης.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {cards.map((c, i) => (
          <div key={i} className="bg-white border border-[#E5E9E4] rounded-sm p-5">
            <div className="flex items-center justify-between mb-3">
              <span className="p-2 rounded-sm bg-[#E8F0E1] text-[#1E3A2F]"><c.icon className="h-5 w-5" /></span>
              {c.to && <Link to={c.to} className="text-[#536D61] hover:text-[#1E3A2F]"><ArrowRight className="h-4 w-4" /></Link>}
            </div>
            <p className="text-2xl font-semibold text-[#1E3A2F]" data-testid={`stat-${i}`}>{c.value}</p>
            <p className="text-sm text-[#536D61]">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white border border-[#E5E9E4] rounded-sm p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-semibold text-[#1E3A2F]">Πρόσφατες παραγγελίες</h2>
          <Link to="/admin/orders" className="text-sm text-[#536D61] hover:text-[#1E3A2F] flex items-center gap-1">Όλες <ArrowRight className="h-4 w-4" /></Link>
        </div>
        {stats?.recent_orders?.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[#536D61] border-b border-[#E5E9E4]">
                  <th className="py-2 pr-4 font-medium">Πελάτης</th>
                  <th className="py-2 pr-4 font-medium">Κατάσταση</th>
                  <th className="py-2 pr-4 font-medium">Πληρωμή</th>
                  <th className="py-2 pr-4 font-medium text-right">Σύνολο</th>
                </tr>
              </thead>
              <tbody>
                {stats.recent_orders.map((o) => (
                  <tr key={o.id} className="border-b border-[#F0F2EE]">
                    <td className="py-2.5 pr-4 text-[#1E3A2F]">{o.customer?.name}</td>
                    <td className="py-2.5 pr-4"><span className="text-xs bg-[#E8F0E1] text-[#1E3A2F] px-2 py-1 rounded-sm">{o.status}</span></td>
                    <td className="py-2.5 pr-4 text-[#536D61]">{o.payment_method === "cod" ? "Αντικαταβολή" : "Κάρτα"}</td>
                    <td className="py-2.5 pr-4 text-right font-medium">{eur(o.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-[#536D61] text-sm py-6 text-center">Δεν υπάρχουν παραγγελίες ακόμη.</p>
        )}
      </div>
    </div>
  );
}
